import { Injectable } from '@angular/core';
import { ApiHttpClient} from '../modules/tcm-core.module';
import { ReportGroupViewModel } from '../models/reports';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';


@Injectable({
  providedIn: 'root'
})
export class ReportsDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getAvailableReportsAsync(cancellationToken: Promise<any>): Promise<ReportGroupViewModel[]> {
    return this.httpClient.getJsonAsync<ReportGroupViewModel[]>('Reports/GetReportsByGroup', {}, cancellationToken);
  }

  private getReceiptFileBlobAsync(depositId: number): Promise<FileResponse> {
    return this.httpClient.getFileAsync(`Reports/DownloadReceipt?depositId=${depositId}`);
  }

  public async downloadAndSaveReceiptFileAsync(depositId: number): Promise<any> {
    try {
      var fileResponse = await this.getReceiptFileBlobAsync(depositId);

      fileResponse.save();      
    }
    catch (e) {

    }
  }
}
